import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-uploadded-files-list',
  templateUrl: './uploadded-files-list.component.html',
  styleUrls: ['./uploadded-files-list.component.scss']
})
export class UploaddedFilesListComponent implements OnInit {

  @Input() files?: any[] = [];
  constructor() { }

  ngOnInit(): void {
  }

}
